import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ThankYou() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000); // Redirect after 5 seconds

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f7fa'
    }}>
      <h1 style={{ fontSize: '2.5rem', color: '#2c3e50', marginBottom: '16px' }}>🎉 Thank You!</h1>
      <p style={{ fontSize: '1.25rem', color: '#34495e' }}>
        Your information has been successfully submitted.<br />
        We'll be in touch with you shortly!
      </p>
      <p style={{ marginTop: '24px', fontSize: '0.9rem', color: '#777' }}>
        Redirecting you to the form in 5 seconds…
      </p>
    </div>
  );
}
